export const config = {
  endpoints: {
    /* eslint-disable no-undef */
    // During build, VUE will replace process.env.VUE_APP_xxxxxx with the string from .env
    dealers : 'https://intense-harbor-59780.herokuapp.com/locator.caseih.com/api/dealership/CASE_IH_BRAND/find/{country}/@{latitude},{longitude}~R:50mi',
    construction : 'https://intense-harbor-59780.herokuapp.com/locator.casece.com/api/dealership/CASE_CE_BRAND/find/{country}/@{latitude},{longitude}~R:50mi',
    agriculture : 'https://intense-harbor-59780.herokuapp.com/locator.newholland.com/api/dealership/NH_AG_BRAND/find/{country}/@43.1062868,-87.9067205~R:50mi',
    /* eslint-enabele no-undef */
    
// http://stg-locator.caseih.com
// http://stg-locator.newholland.com
  },
  defaults: {},
  keys : {
    caseAPI : process.env.VUE_APP_API_KEY
  }
};
